export default __webpack_public_path__ + "static/media/blogging.1751e16b.png";